import { Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

export const InvalidInvitationWrapper = styled.div`
  text-align: center;
  max-width: 668px;
  margin: ${Spacing.S40} auto 0;
`
